import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import styled, { css } from 'styled-components';

import { addEmptyChoice, setIsEventFinish, deleteAllChoices } from '@Services/Editor';

import { ReactComponent as SelectionCheckOnSVG } from '@Assets/Svgs/selection_check_on.svg';
import TX from '@Components/Common/Text';

import ProcessShowMoreButton from './ProcessShowMoreButton';
import NoticeEventFinishModal from './NoticeEventFinishModal';

const Header = ({ processId, snackBarRef }) => {
  const dispatch = useDispatch();
  const isEventFinish = useSelector(({ editor }) => editor?.processes[processId]?.isEventFinish);
  const [isNoticeEventFinishModalVisible, setIsNoticeEventFinishModalVisible] = useState(false);

  const handleIsNoticeEventFinishModalVisible = useCallback(() => {
    setIsNoticeEventFinishModalVisible(!isNoticeEventFinishModalVisible);
  }, [isNoticeEventFinishModalVisible]);

  const handleAddEmptyChoice = useCallback(() => {
    dispatch(addEmptyChoice({ processId }));
  }, [dispatch]);

  const handleSetIsEventFinish = useCallback(() => {
    dispatch(setIsEventFinish({ processId }));
  }, [dispatch]);

  const handleDeleteAllChoices = useCallback(() => {
    dispatch(deleteAllChoices({ processId }));
  }, [dispatch]);

  const handleEventFinishOfShowMoreButtonClick = () => {
    if (isEventFinish) {
      handleAddEmptyChoice();
      handleSetIsEventFinish();
    } else {
      handleIsNoticeEventFinishModalVisible();
    }
  };

  const handleEventFinishClick = () => {
    handleDeleteAllChoices();
    handleSetIsEventFinish();
    handleIsNoticeEventFinishModalVisible();
  };

  return (
    <>
      <HeaderContainer>
        <LeftContainer>
          <ProcessIdText>P. {processId}</ProcessIdText>

          {/* {!isValidationPassed && <NonCompletionNotice text="비어있는 항목이 있습니다." />} */}
        </LeftContainer>

        <RightContainer>
          {isEventFinish && (
            <LastEventContainer>
              <SelectedIcon />
              <TX.FootnoteM>마지막 페이지</TX.FootnoteM>
            </LastEventContainer>
          )}

          <ProcessShowMoreButton
            processId={processId}
            isEventFinish={isEventFinish}
            handleEventFinishOfShowMoreButtonClick={handleEventFinishOfShowMoreButtonClick}
            snackBarRef={snackBarRef}
          />
        </RightContainer>
      </HeaderContainer>

      <NoticeEventFinishModal
        isNoticeEventFinishModalVisible={isNoticeEventFinishModalVisible}
        handleEventFinishClick={handleEventFinishClick}
        handleIsNoticeEventFinishModalVisible={handleIsNoticeEventFinishModalVisible}
      />
    </>
  );
};

Header.propTypes = {
  processId: PropTypes.number.isRequired,
};

const FlexAlignCenterCSS = css`
  display: flex;
  align-items: center;
`;

const HeaderContainer = styled.div`
  ${FlexAlignCenterCSS}
  position: relative;
`;

const LeftContainer = styled.div`
  ${FlexAlignCenterCSS}

  flex: 1;
  gap: 8px;
`;

const ProcessIdText = styled(TX.BodyB)`
  margin-right: 4px;
`;

const RightContainer = styled.div`
  ${FlexAlignCenterCSS}
  justify-content: center;

  position: relative;
`;

const LastEventContainer = styled.div`
  ${FlexAlignCenterCSS}
  justify-content: center;

  padding: 8px;
  gap: 0px 8px;
`;

const SelectedIcon = styled(SelectionCheckOnSVG)`
  width: 16px;
  height: 16px;

  fill: ${({ theme }) => theme.colors.ui_on_4};
`;

export default Header;
